export default __webpack_public_path__ + "static/media/Logo.4a35bdbc.ico";